import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { QuestionSettingsModule } from '../../question-settings';
import { QuestionTitleModule } from '../../question-title';
import { FocusItemModule } from '../../../../shared';

import { QuestionComponent } from './question.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuestionConditionsModule } from '../../question-conditions';

@NgModule({
  imports: [
    TooltipModule.forRoot(), // basic tooltip
    FormsModule, ReactiveFormsModule,
  ],
  declarations: [QuestionComponent],
  exports:[
    CommonModule, 
    FormsModule, ReactiveFormsModule,
    QuestionSettingsModule, // question-setting
    QuestionTitleModule, // question-title
    FocusItemModule, // focus system
    TooltipModule, // basic tooltip
    QuestionConditionsModule,
  ],

})
export class QuestionModule { }
